export const required = (description) => (value) => (!value || value.trim() === '' ? description : undefined);

export const match = (re, description) => (value) => (!value.match(re) ? description : undefined);

export const list = (...validators) => (value) => validators.reduce(
  (result, validator) => result || validator(value),
  undefined
);

export const hasError = (validationErrors, fieldName) => validationErrors[fieldName] !== undefined;
